export function parseDate(date: unknown) {
  if (date === null) return null;
  if (typeof date !== 'string' && !(date instanceof Date)) return undefined;

  const localDate = new Date(date);
  if (localDate.toString() === 'Invalid Date') return undefined;

  return new Date(localDate.getUTCFullYear(), localDate.getUTCMonth(), localDate.getUTCDate(), 12, 0, 0);
}
